'use client'

import * as Sentry from '@sentry/nextjs'
import type { User } from '@/lib/types/database'
import { setTenantContext, clearTenantContext } from './tenant'

/**
 * ログイン成功後に Sentry のユーザーコンテキストをセットする。
 * エラー発生時に「誰のセッションで起きたか」を Sentry ダッシュボードで特定できるようにする。
 */
export function setSentryUser(user: User) {
  // Pマーク対応: UUID のみ送信（email/name は米国 Sentry サーバーに送信しない）
  // UUID は G-Force DB との照合なしに個人を特定できないため仮名加工情報扱い
  // コード外対応: Sentry DPA 締結 + プライバシーポリシーへの開示が別途必要
  Sentry.setUser({ id: user.id })
  Sentry.setTag('user.role', user.role ?? 'unknown')
  setTenantContext(user.tenantId)
}

/**
 * ログアウト時に Sentry のユーザーコンテキストをクリアする。
 */
export function clearSentryUser() {
  Sentry.setUser(null)
  clearTenantContext()
}
